import React, { Fragment, useState, useEffect } from "react";
import Header from "../common/header";
import Footer from "../common/footer";
import CollectionInnerPageBanner from "./collection-inner-page-banner";
import CollectionInnerAbout from "./collection-inner-about";
import CollectionInnerWalkthrough from "./collection-inner-walkthrough";
import CollectionInnerAmenities from "./collection-inner-page-amenities";
import CollectionInnerFeatures from "./collection-inner-features";
import CollectionInnerLayouts from "./collection-inner-layouts";
import CollectionInnerPayments from "./collection-inner-payment";
import CollectionInnerLocation from "./collection-inner-location";
import CollectionInnerConstruction from "./collection-inner-construction";
import CollectionInnerLivingSpace from "./collection-inner-livingspace";
import { useParams } from "react-router-dom";
import * as apiUrl from "../../apiUrl";

import logo from "../../assets/marquis-logo.svg";

function CollectionPage() {
  const { slug } = useParams();
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);

  const [sections, setSections] = useState({});

  useEffect(() => {
    const fetchData = async (endpoint, sectionKey) => {
      try {
        const response = await fetch(
          `${apiUrl.apiUrl}/api/collection-inner/${endpoint}/${slug}`,
        );
        if (!response.ok) throw new Error(`${sectionKey} not found`);
        const data = await response.json();
        setSections((prev) => ({ ...prev, [sectionKey]: data }));
      } catch (error) {
        console.error(`Error fetching ${sectionKey}:`, error);
      }
    };

    // Reset loading and sections when the slug changes
    setLoading(true);
    setSections({});

    const fetchAllSections = async () => {
      await Promise.all([
        fetchData("page", "page"),
        fetchData("second-section", "second_section"),
        fetchData("amenities", "amenities_section"),
        fetchData("features", "features_section"),
        fetchData("living", "living_section"),
        fetchData("layouts", "layout_section"),
        fetchData("payments", "payment_section"),
        fetchData("location", "location_section"),
        fetchData("construction", "construction_section"),
      ]);
      setLoading(false); // Once all data is fetched, set loading to false
    };

    fetchAllSections();
  }, [slug]); // Dependency on `slug` ensures this effect runs every time the URL changes

  if (loading) {
    return (
      <div className="loading-container">
        <img src={logo} alt="Loading" className="loading-logo" />
      </div>
    );
  }

  if (!sections.page) {
    return <p>Page not found.</p>;
  }

  const {
    page,
    second_section,
    amenities_section,
    features_section,
    living_section,
    layout_section,
    payment_section,
    location_section,
    construction_section,
  } = sections;

  return (
    <Fragment>
      <Header />

      <CollectionInnerPageBanner bannerImage={page.banner_image} />
      {second_section && (
        <CollectionInnerAbout
          title={second_section.title}
          subTitle={second_section.sub_title}
          description={second_section.description}
          leftImage={second_section.left_image}
          rightImage={second_section.right_image}
          brochure={second_section.brochure_pdf}
        />
      )}
      <CollectionInnerWalkthrough walkthroughLink={page.walkthrough_link} />
      {amenities_section && (
        <CollectionInnerAmenities amenities={amenities_section} />
      )}
      {features_section && (
        <CollectionInnerFeatures features={features_section} />
      )}
      {living_section && <CollectionInnerLivingSpace living={living_section} />}

      {layout_section &&
      slug !== "marquis-horizon" && (
        <CollectionInnerLayouts
          layouts={layout_section}
          title={second_section.title}
          brochure={second_section.brochure_pdf}
          slug={slug}
        />
      )}

      {payment_section &&
        slug !== "marquis-signature" &&
        slug !== "2020-marquis" && (
          <CollectionInnerPayments
            paymentSectionBgImage={payment_section.payment_section_bg_image}
            paymentPlans={payment_section}
          />
        )}

      {location_section && (
        <div
          className={
            (!payment_section ||
              slug === "marquis-signature" ||
              slug === "2020-marquis") &&
            location_section
              ? "location-section-padding"
              : ""
          }
        >
          <CollectionInnerLocation location={location_section} />
        </div>
      )}
      {construction_section && (
        <CollectionInnerConstruction
          construction={construction_section}
          lastImage={page.last_image}
          slug={page.slug}
        />
      )}

      <Footer />
    </Fragment>
  );
}

export default CollectionPage;
